export default {
	'THEME': 'kitchenrepublic',
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_CHILDPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_ORDERBOX_DELIVERY": true,
	"FEATURE_ORDERBOX_TAKEAWAY": true,
	"FEATURE_ORDERBOX_REGIONS": true,
	"FEATURE_ORDERBOX_GEOLOCATION": true,
}
